const todoItems = {
  checkAll: 'Check All',
  createTodoList: 'Create To-do List',
  editTodoList: 'Edit To-do List',
  plural: 'To-do List',
  uncheckAll: 'Uncheck All',
  enterListTitle: 'Enter list title',
  extractToDoItemsFromWhiteboard: 'Extract to-do items from whiteboard',
  confirmCloseWithoutSavingMessage:
    'Data will not be saved after closing. Are you sure you want to exit?'
};

export default todoItems;
